import script from "./WarningCodesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningCodesComponent.vue?vue&type=script&setup=true&lang=js"

import "./WarningCodesComponent.vue?vue&type=style&index=0&id=21c5e7bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c5e7bc"]])

export default __exports__